import React from 'react';
import { Col,Row } from 'react-bootstrap';

function WeatherItem(props) {
    return (
            <Col xs={12} lg={2}>
                <Row>
                    <Col xs={4} lg={12} className="my-auto text-right text-lg-center pl-0">{props.ItemDay}</Col>
                    <Col xs={4} lg={12} className="text-center">{props.ItemIcon}</Col>
                    <Col xs={4} lg={12} className="text-center my-auto pr-0">{props.ItemHightTemp}° / {props.ItemlowTemp}°</Col>
                </Row>
            </Col>
    )
}
export default WeatherItem;